import { useSelector } from 'react-redux';
import { EnumRoles } from '../enums/Enums';

export const useIsAdmin = () => {
  const userProfile = useSelector((state) => state.userProfileData);
  const roles = userProfile?.roles || [];
  return roles.includes(EnumRoles.ADMIN);
};
